import { render, staticRenderFns } from "./India.vue?vue&type=template&id=9087c104&"
import script from "./India.vue?vue&type=script&lang=js&"
export * from "./India.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9087c104')) {
      api.createRecord('9087c104', component.options)
    } else {
      api.reload('9087c104', component.options)
    }
    module.hot.accept("./India.vue?vue&type=template&id=9087c104&", function () {
      api.rerender('9087c104', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/India.vue"
export default component.exports